import { S3_URL } from 'constants/index';

const StassifyLogo = `${S3_URL}web-assets-public/jobstas-logo.webp`;
const StassifyLogoHeader = `${S3_URL}web-assets-public/jobstas-logo-header.webp`;
const WhatIsStassifyImg = `${S3_URL}web-assets-public/what-is-jobstas-img.webp`;
const UsersExpectImg = `${S3_URL}web-assets-public/users-expect-img.webp`;

const StassifyLogoWhite = `${S3_URL}web-assets-public/jobstas-logo-white.svg`;
const GooglePlayIcon = `${S3_URL}web-assets-public/google-play-icon.webp`;
const AppStoreIcon = `${S3_URL}web-assets-public/app-store-icon.webp`;
const JobLogo1 = `${S3_URL}web-assets-public/job-logo1.png`;
const JobLogo2 = `${S3_URL}web-assets-public/job-logo2.png`;
const JobLogo3 = `${S3_URL}web-assets-public/job-logo3.png`;
const JobLogo4 = `${S3_URL}web-assets-public/job-logo4.png`;
const HowItWorksImg = `${S3_URL}web-assets-public/how-it-works-img.webp`;
const DownloadAppImg = `${S3_URL}web-assets-public/download-app-img.png`;
const GooglePlayBtn = `${S3_URL}web-assets-public/google-play-v2.webp`;
const AppStoreBtn = `${S3_URL}web-assets-public/app-store-v2.webp`;
const SliderImg1 = `${S3_URL}web-assets-public/slider-img1.jpg`;
const PlayIcon = `${S3_URL}web-assets-public/play-icon.svg`;
const Arrow = `${S3_URL}web-assets-public/arrow.svg`;
const FacebookIcon = `${S3_URL}web-assets-public/facebook-icon.svg`;
const GoogleIcon = `${S3_URL}web-assets-public/google-icon.svg`;
const AppleIcon = `${S3_URL}web-assets-public/apple-icon.svg`;
const LinkedinIcon = `${S3_URL}web-assets-public/linkedin-icon.svg`;
const TwitterIcon = `${S3_URL}web-assets-public/twitter-icon.svg`;
const UserBG = `${S3_URL}web-assets-public/user-bg.jpg`;
const UserBG2 = `${S3_URL}web-assets-public/user-bg2.jpg`;
const User1 = `${S3_URL}web-assets-public/user1.jpg`;
const User2 = `${S3_URL}web-assets-public/user2.jpg`;
const user3 = `${S3_URL}web-assets-public/user3.jpg`;
const user4 = `${S3_URL}web-assets-public/user4.jpg`;
const user5 = `${S3_URL}web-assets-public/user5.jpg`;
const BrandLogo1 = `${S3_URL}web-assets-public/brand-logo1.png`;
const BrandLogo2 = `${S3_URL}web-assets-public/brand-logo2.png`;
const BrandLogo3 = `${S3_URL}web-assets-public/brand-logo3.png`;
const BrandLogo4 = `${S3_URL}web-assets-public/brand-logo4.svg`;
const UserIcon = `${S3_URL}web-assets-public/user-icon.svg`;
const FoundedIcon = `${S3_URL}web-assets-public/founded-icon.svg`;
const CompanyIcon = `${S3_URL}web-assets-public/company-icon.svg`;
const SuccessGif = `${S3_URL}web-assets-public/success.gif`;
const EnFlag = `${S3_URL}web-assets-public/en-flag.svg`;
const UkFlag = `${S3_URL}web-assets-public/uk-flag.svg`;
const Hashtag = `${S3_URL}web-assets-public/hashtag.jpg`;
const CompanyLogoDefault = `${S3_URL}web-assets-public/company-logo-default.png`;
const UserDefault = `${S3_URL}web-assets-public/avatar.jpg`;
const BlogImg1 = `${S3_URL}web-assets-public/blog-img1.jpg`;
const BlogImg2 = `${S3_URL}web-assets-public/blog-img2.jpg`;
const BlogImg3 = `${S3_URL}web-assets-public/blog-img3.jpg`;
const BlogImg4 = `${S3_URL}web-assets-public/blog-img4.jpg`;
const StoryImg1 = `${S3_URL}web-assets-public/story-img1.jpg`;
const StoryImg2 = `${S3_URL}web-assets-public/story-img2.jpg`;
const StoryImg3 = `${S3_URL}web-assets-public/story-img3.jpg`;
const UploadImg = `${S3_URL}web-assets-public/upload-img.svg`;
const UploadVideo = `${S3_URL}web-assets-public/upload-video.svg`;
const PostImg1 = `${S3_URL}web-assets-public/post-img1.jpg`;
const PostImg2 = `${S3_URL}web-assets-public/post-img2.jpg`;
const PostImg3 = `${S3_URL}web-assets-public/post-img3.jpg`;
const PostImg4 = `${S3_URL}web-assets-public/post-img4.jpg`;
const VideoResumeIcon = `${S3_URL}web-assets-public/video-resume-icon.svg`;
const BrandLogo5 = `${S3_URL}web-assets-public/brand-logo5.png`;
const ForEmployeesImg = `${S3_URL}web-assets-public/for-employees-img1.webp`;
const ForEmployersImg = `${S3_URL}web-assets-public/for-employers-img1.webp`;
const aiwriter = `${S3_URL}web-assets-public/aiwriter.svg`;
const savedtemplate = `${S3_URL}web-assets-public/savedtemplate.svg`;
const templatePhoneIcon = `${S3_URL}web-assets-public/template-icons/phoneicon.png`;
const templateAddressIcon = `${S3_URL}web-assets-public/template-icons/addressicon.png`;
const templateEmailIcon = `${S3_URL}web-assets-public/template-icons/emailicon.png`;
const templateWebsiteIcon = `${S3_URL}web-assets-public/template-icons/websiteicon.png`;
const educationLogo = `${S3_URL}web-assets-public/template-icons/education-logo.png`;
const educationLogo2 = `${S3_URL}web-assets-public/template-icons/education-logo2.png`;
const educationLogo3 = `${S3_URL}web-assets-public/template-icons/education-logo3.png`;
const instaIcon = `${S3_URL}web-assets-public/template-icons/insta-icon.png`;
const dribbleIcon = `${S3_URL}web-assets-public/template-icons/dribble-icon.png`;
const flagIcon1 = `${S3_URL}web-assets-public/template-icons/flag-icon1.png`;
const flagIcon2 = `${S3_URL}web-assets-public/template-icons/flag-icon2.png`;
const flagIcon3 = `${S3_URL}web-assets-public/template-icons/flag-icon3.png`;
const urlIcon = `${S3_URL}web-assets-public/template-icons/url-icon.png`;
const companyLogo1 = `${S3_URL}web-assets-public/template-icons/company-logo1.png`;
const companyLogo2 = `${S3_URL}web-assets-public/template-icons/company-logo2.png`;
const companyLogo3 = `${S3_URL}web-assets-public/template-icons/company-logo3.png`;
const hobbyIcon1 = `${S3_URL}web-assets-public/template-icons/hobby-icon1.png`;
const hobbyIcon2 = `${S3_URL}web-assets-public/template-icons/hobby-icon2.png`;
const hobbyIcon3 = `${S3_URL}web-assets-public/template-icons/hobby-icon3.png`;
const hobbyIcon4 = `${S3_URL}web-assets-public/template-icons/hobby-icon4.png`;
const hobbyIcon5 = `${S3_URL}web-assets-public/template-icons/hobby-icon5.png`;
const hobbyIcon6 = `${S3_URL}web-assets-public/template-icons/hobby-icon6.png`;
const hobbyIcon7 = `${S3_URL}web-assets-public/template-icons/hobby-icon7.png`;
const hobbyIcon8 = `${S3_URL}web-assets-public/template-icons/hobby-icon8.png`;
const hobbyIcon9 = `${S3_URL}web-assets-public/template-icons/hobby-icon9.png`;
const hobbyIcon10 = `${S3_URL}web-assets-public/template-icons/hobby-icon10.png`;
const profileFrame = `${S3_URL}web-assets-public/template-icons/profile-frame.png`;
const template2BottomBG = `${S3_URL}web-assets-public/template-icons/template2-bottom-bg.png`;
const PositiveSslIcon = `${S3_URL}web-assets-public/positive-ssl-icon.png`;
const SectigoIcon = `${S3_URL}web-assets-public/sectigo-icon.png`;
const awsIcon = `${S3_URL}web-assets-public/aws-icon.webp`;
const chatbotIcon = `${S3_URL}web-assets-public/chatbot-icon.png`;
const smallLogo = `${S3_URL}web-assets-public/favicon.png`;
const authBG = `${S3_URL}web-assets-public/auth-bg.png`;

export const IMAGE_PATHS = {
	StassifyLogo: StassifyLogo,
	StassifyLogoHeader: StassifyLogoHeader,
	StassifyLogoWhite: StassifyLogoWhite,
	GooglePlayIcon: GooglePlayIcon,
	AppStoreIcon: AppStoreIcon,
	PositiveSslIcon: PositiveSslIcon,
	SectigoIcon: SectigoIcon,
	AwsIcon: awsIcon,
	JobLogo1: JobLogo1,
	JobLogo2: JobLogo2,
	JobLogo3: JobLogo3,
	JobLogo4: JobLogo4,
	ForEmployeesImg: ForEmployeesImg,
	ForEmployersImg: ForEmployersImg,
	WhatIsStassifyImg: WhatIsStassifyImg,
	UsersExpectImg: UsersExpectImg,
	HowItWorksImg: HowItWorksImg,
	DownloadAppImg: DownloadAppImg,
	GooglePlayBtn: GooglePlayBtn,
	AppStoreBtn: AppStoreBtn,
	SliderImg1: SliderImg1,
	PlayIcon: PlayIcon,
	Arrow: Arrow,
	FacebookIcon: FacebookIcon,
	GoogleIcon: GoogleIcon,
	AppleIcon: AppleIcon,
	LinkedinIcon: LinkedinIcon,
	TwitterIcon: TwitterIcon,
	UserBG: UserBG,
	UserBG2: UserBG2,
	User1: User1,
	User2: User2,
	user3: user3,
	user4: user4,
	user5: user5,
	BrandLogo1: BrandLogo1,
	BrandLogo2: BrandLogo2,
	BrandLogo3: BrandLogo3,
	BrandLogo4: BrandLogo4,
	BrandLogo5: BrandLogo5,
	UserIcon: UserIcon,
	FoundedIcon: FoundedIcon,
	CompanyIcon: CompanyIcon,
	SuccessGif: SuccessGif,
	EnFlag: EnFlag,
	UkFlag: UkFlag,
	Hashtag: Hashtag,
	CompanyLogoDefault: CompanyLogoDefault,
	UserDefault: UserDefault,
	BlogImg1: BlogImg1,
	BlogImg2: BlogImg2,
	BlogImg3: BlogImg3,
	BlogImg4: BlogImg4,
	StoryImg1: StoryImg1,
	StoryImg2: StoryImg2,
	StoryImg3: StoryImg3,
	UploadImg: UploadImg,
	UploadVideo: UploadVideo,
	PostImg1: PostImg1,
	PostImg2: PostImg2,
	PostImg3: PostImg3,
	PostImg4: PostImg4,
	VideoResumeIcon: VideoResumeIcon,
	aiwriter: aiwriter,
	savedtemplate: savedtemplate,
	templatePhoneIcon: templatePhoneIcon,
	templateAddressIcon: templateAddressIcon,
	templateEmailIcon: templateEmailIcon,
	templateWebsiteIcon: templateWebsiteIcon,
	educationLogo: educationLogo,
	educationLogo2: educationLogo2,
	educationLogo3: educationLogo3,
	instaIcon: instaIcon,
	dribbleIcon: dribbleIcon,
	flagIcon1: flagIcon1,
	flagIcon2: flagIcon2,
	flagIcon3: flagIcon3,
	urlIcon: urlIcon,
	companyLogo1: companyLogo1,
	companyLogo2: companyLogo2,
	companyLogo3: companyLogo3,
	hobbyIcon1: hobbyIcon1,
	hobbyIcon2: hobbyIcon2,
	hobbyIcon3: hobbyIcon3,
	hobbyIcon4: hobbyIcon4,
	hobbyIcon5: hobbyIcon5,
	hobbyIcon6: hobbyIcon6,
	hobbyIcon7: hobbyIcon7,
	hobbyIcon8: hobbyIcon8,
	hobbyIcon9: hobbyIcon9,
	hobbyIcon10: hobbyIcon10,
	profileFrame: profileFrame,
	template2BottomBG: template2BottomBG,
	chatbotIcon: chatbotIcon,
	smallLogo: smallLogo,
	authBG: authBG,
};
